import {
  OffTargetVariant2Icon,
  OnTargetVariant2Icon,
  RedCardIcon,
  YellowCardIcon,
} from '@/common/assets';
import { useNewTranslations } from '@/common/translations';

import { PlayerStatsOptionValues } from '../../constants';
import type { PlayerStatsOption } from '../../types';

interface PlayersStatsLegendProps {
  activeFilter: PlayerStatsOption;
}

const legendMapping = {
  [PlayerStatsOptionValues.SHOTS]: [
    {
      translationKey: 'PreMatchStats.OffTarget',
      icon: (
        <OffTargetVariant2Icon className="shrink-0 text-pmw-if-secondary-light dark:text-pmw-if-secondary-dark" />
      ),
    },
    {
      translationKey: 'PreMatchStats.OnTarget',
      icon: (
        <OnTargetVariant2Icon className="shrink-0 text-pmw-if-secondary-light dark:text-pmw-if-secondary-dark" />
      ),
    },
  ],
  [PlayerStatsOptionValues.CARDS]: [
    {
      translationKey: 'PreMatchStats.YellowCards',
      icon: <YellowCardIcon className="shrink-0 h-[12px] mx-[-4px]" />,
    },
    {
      translationKey: 'PreMatchStats.RedCards',
      icon: <RedCardIcon className="shrink-0 h-[12px] mx-[-4px]" />,
    },
  ],
  [PlayerStatsOptionValues.GOALS]: [],
  [PlayerStatsOptionValues.ASSISTS]: [],
  [PlayerStatsOptionValues.INJURED]: [],
};

export default function PlayersStatsLegend({ activeFilter }: PlayersStatsLegendProps) {
  const translate = useNewTranslations();

  const legendForActiveFilter = legendMapping[activeFilter];

  if (!legendForActiveFilter || legendForActiveFilter.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2.5 p-2">
      {legendForActiveFilter.map(({ translationKey, icon }) => (
        <div key={translationKey} className="flex items-center gap-2">
          {icon}
          <span className="truncate font-robotoMedium font-medium text-[10px] leading-[16px] text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark">
            {translate(translationKey)}
          </span>
        </div>
      ))}
    </div>
  );
}
